<!-- hijri-date-picke.component.html with default colors -->
<div class="relative w-full" (clickOutside)="closeDatepicker($event)">
  <label *ngIf="label" class="block text-md font-semibold mb-4">{{ label }}</label>

  <div class="relative group">
    <input type="text" [value]="displayValue" [placeholder]="placeholder" [disabled]="disabled"
      (click)="toggleDatepicker()" readonly class="block w-full rounded-md border border-gray-300 shadow-sm sm:text-sm p-[8.5px] cursor-pointer transition-all duration-200
             focus:border-gray-500 focus:ring-2 focus:ring-gray-200 focus:ring-opacity-50
             group-hover:border-gray-400" [ngClass]="{'bg-gray-100': disabled, 'cursor-not-allowed': disabled}" />

    <div class="absolute inset-y-0 left-2 flex items-center pr-3 text-gray-500 group-hover:text-gray-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 transition-transform group-hover:scale-110" fill="none"
        viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    </div>
  </div>

  <!-- Hijri Calendar Popup -->
  <div *ngIf="isOpen" class="hijri-datepicker absolute z-10 mt-2 w-80 rounded-md shadow-xl bg-white p-5 border border-gray-200
           transition-all duration-300 ease-in-out transform" dir="rtl">

    <!-- Header with neutral background -->
    <div class="rounded-lg bg-gray-100 text-gray-800 p-4 mb-4">
      <!-- Month Navigation -->
      <div class="flex items-center justify-between mb-2">

        <button type="button"
          class="border-none cursor-pointer hover:scale-105 transition-all duration-200 ease-in-out flex justify-center items-center"
          title="الشهر التالي" (click)="nextMonth()">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
        <div class="font-bold text-xl">{{ months[hijriMonth] }}</div>
        <button type="button"
          class="border-none  cursor-pointer hover:scale-105 transition-all duration-200 ease-in-out flex justify-center items-center"
          title="الشهر السابق" (click)="prevMonth()">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      </div>

      <!-- Year Selection with neutral design -->
      <div class="flex items-center justify-center mt-2 bg-white rounded-full py-1 px-3 w-max mx-auto shadow-sm">
        <button type="button"
          class="border-none bg-white cursor-pointer hover:scale-105 transition-all duration-200 ease-in-out flex justify-center items-center"
          (click)="changeYear(-1)">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        <div class="font-semibold mx-2 text-lg text-gray-800">{{ toArabicNumeral(hijriYear) }}</div>
        <button type="button"
          class="border-none bg-white cursor-pointer hover:scale-105 transition-all duration-200 ease-in-out flex justify-center items-center"
          (click)="changeYear(1)">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Days of Week Header with neutral design -->
    <div class="grid grid-cols-7 gap-1 text-center mb-3">
      <div *ngFor="let day of daysOfWeek.slice().reverse()" class="text-xs font-medium py-2"
        [ngClass]="{'text-gray-800 font-bold': day === 'الجمعة', 'text-gray-500': day !== 'الجمعة'}">
        {{ day }}
      </div>
    </div>

    <!-- Calendar Days with neutral styling -->
    <div class="grid grid-cols-7 gap-1 mb-4">
      <ng-container *ngFor="let week of calendarDays">
        <ng-container *ngFor="let day of week">
          <button type="button" (click)="selectDay(day)" class="w-9 h-9 flex items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-offset-1
                   focus:ring-gray-300 transition-all duration-200 text-sm relative" [ngClass]="{
              'text-gray-400 hover:bg-gray-50': !day.isCurrentMonth,
              'text-gray-700 hover:bg-gray-50': day.isCurrentMonth && !day.isToday && (!selectedDate || !selectedDate.isSame(day.date, 'day')),
              'bg-gray-200 text-gray-800 hover:bg-gray-300 ring-1 ring-gray-300': day.isToday && (!selectedDate || !selectedDate.isSame(day.date, 'day')),
              'bg-gray-800 text-white hover:bg-gray-700 shadow-sm': selectedDate && selectedDate.isSame(day.date, 'day')
            }">
            {{ toArabicNumeral(day.day) }}
            <!-- Highlight for today's date -->
            <span *ngIf="day.isToday && (!selectedDate || !selectedDate.isSame(day.date, 'day'))"
              class="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-gray-600 rounded-full"></span>
          </button>
        </ng-container>
      </ng-container>
    </div>

    <!-- Footer with action buttons -->
    <div class="flex justify-between items-center pt-2 border-t border-gray-200">
      <button type="button" (click)="selectToday()"
        class="text-sm bg-gray-100 text-gray-700 hover:bg-gray-200 py-1.5 px-3 rounded-full transition-colors">
        <span class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          اليوم
        </span>
      </button>

      <button type="button" (click)="isOpen = false"
        class="text-sm bg-gray-100 text-gray-600 hover:bg-gray-200 py-1.5 px-3 rounded-full transition-colors">
        <span class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          إغلاق
        </span>
      </button>
    </div>
  </div>
</div>